
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import lottie, {AnimationItem} from "lottie-web";
import {configManager} from "@/app/services/config.manager";
import {DynamicFormEntry} from "@/app/dynamic-components/forms/dynamic-form.model";
import {RenderType} from "@/app/Types";
import {detailComponentLookup} from "@/app/dynamic-components/details/details-components/detail-component.lookup";
import {ComponentTypeDictionaryService} from "@/app/dynamic-components/forms/form-components/form-component.lookup";
import {formValidatorLookup} from "@/app/dynamic-components/forms/form-validations/form-validator.lookup";
import {DynamicDetailEntry, dynamicDetailEntryToDefinition} from "@/app/dynamic-components/details/dynamic-detail.model";

@Component({
  components: {  },
})
export default class DynamicComponentConfigManager extends Vue {
  private i = 0;
  isFormEntry = false;
  isDetailEntry = false;

  displayModeList = ["editable","inherit","readonly","rule","hidden"];
  formtypeList = ComponentTypeDictionaryService.getComponentList();
  detailstypeList = detailComponentLookup.getComponentList();
  validatorsList = formValidatorLookup.getValidatorsList();
  selectedValidator: string | null = null;
  validators: {
    func: string,
    vars: string
  }[] = [];
  metadata = '';

  @Prop({
    default: () => {
      return null;
    }
  })
  entry!: DynamicFormEntry | DynamicDetailEntry | null;

  @Watch("entry", { immediate: true })
  onEntryChanged(newValue: DynamicFormEntry | DynamicDetailEntry, oldValue: DynamicFormEntry | DynamicDetailEntry) {
    if(this.entry){
      this.isFormEntry = this.entry instanceof DynamicFormEntry;
      this.isDetailEntry = !(this.entry instanceof DynamicFormEntry);

      if(this.entry instanceof DynamicFormEntry){
        if(!this.entry.validatorsNames) {
          this.validators = [];
          return;
        }

        this.validators = [];
        this.entry.validatorsNames.forEach(v => {
          const index = v.indexOf('(');
          if(index < 0){
            this.validators.push({func: v, vars: ''})
            return;
          }
          this.validators.push({func: v.substring(0,index), vars: v.substring(index+1).substring(0,v.substring(index+1).length-1)})
        })
      }

      this.metadata = JSON.stringify(this.entry.metadata, null, 2);
      return;
    }
  }

  public copyJson(prettify: boolean){
    if(!this.entry) return;

    const obj = (this.entry instanceof DynamicFormEntry) ? this.entry?.toDefinition() : dynamicDetailEntryToDefinition(this.entry);

    const json = JSON.stringify(obj, null, prettify? 2 : undefined);
    navigator.clipboard.writeText(json)
        .then(() => Vue.$toast.success('Json copied to clipboard'))
        .catch(err => Vue.$toast.error('Failed to copy to clipboard'));
  }

  validatorSelected(newValue: string | undefined){
    if(newValue && this.entry instanceof DynamicFormEntry){
      this.selectedValidator = null;
      this.validators.push({func: newValue, vars: ''})
      this.entry?.resolveValidators(this.validators.map(value => value.func + '(' + value.vars + ')'))
    }
  }

  removeValidator(validator){
    if(!(this.entry instanceof DynamicFormEntry)) return;
    const indexOf = this.validators.indexOf(validator);
    if(indexOf >= 0){
      this.validators.splice(indexOf, 1);
      this.entry?.resolveValidators(this.validators.map(value => value.func + '(' + value.vars + ')'))
    }
  }

  changeValidator(validator){
    setTimeout(()=>{
      if(!(this.entry instanceof DynamicFormEntry)) return;
      this.entry?.resolveValidators(this.validators.map(value => value.func + '(' + value.vars + ')'))
    }, 100)
  }

  changeMetadata(metadata){
    setTimeout(()=>{
      if(!this.entry) return;
      this.entry.metadata = JSON.parse(this.metadata);
    }, 100)
  }

  canShowElement(): boolean{
    if(configManager.showHiddenDynamicComponentsEnabled()){
      return true;
    }
    if(this.entry instanceof DynamicFormEntry){
      const displayMode = this.entry?.resolvedDisplayMode();
      return displayMode !== "hidden";
    }else{
      return this.entry?.displayMode !== "hidden";
    }
  }

  debugDynamicComponentsEnabled() : boolean {
    return configManager.debugDynamicComponentsEnabled();
  }

  configDynamicComponentsEnabled() : boolean {
    return configManager.modifyDynamicComponentsEnabled();
  }

  mounted() {
    return
  }


  beforeDestroy() {
    return;
  }

  showSettingsPanel = false;
  panelStyle: any = {
    position: 'fixed',
    top: '0px',
    left: '0px'
  };
  togglesettings(){
    this.showSettingsPanel = !this.showSettingsPanel;
    this.$nextTick(() => {
      if (this.showSettingsPanel && this.$refs && this.$refs.iconRef) {
        const icon = this.$refs.iconRef['$el'] || this.$refs.iconRef;
        const rect = icon.getBoundingClientRect();

        this.panelStyle = {
          position: 'fixed',
          top: `${rect.top}px`,
          left: `${rect.right + 8}px`, // 8px space to the right
          zIndex: 10000,
          background: '#fff',
          border: '1px solid #ccc',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
          padding: '12px',
          minWidth: '200px'
        };

        console.warn(this.panelStyle);

      }
    });
  }
  togglesettings2(){
    this.showSettingsPanel = !this.showSettingsPanel;
    this.$nextTick(() => {
      if (this.showSettingsPanel && this.$refs && this.$refs.iconRef2) {
        const icon = this.$refs.iconRef2['$el'] || this.$refs.iconRef2;
        const rect = icon.getBoundingClientRect();

        this.panelStyle = {
          position: 'fixed',
          top: `${rect.top}px`,
          left: `${rect.right + 8}px`, // 8px space to the right
          zIndex: 10000,
          background: '#fff',
          border: '1px solid #ccc',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
          padding: '12px',
          minWidth: '200px'
        };

        console.warn(this.panelStyle);

      }
    });
  }


  applySettings(){
    this.i += 1;
  }

}
